import {
  Container,
  Button,
} from './index'

interface CallToActionProps {
  title: string
  description: string
  primaryAction?: {
    text: string
    onClick?: () => void
    to?: string
  }
  secondaryAction?: {
    text: string
    onClick?: () => void
    to?: string
  }
  className?: string
  variant?: 'blue' | 'slate' | 'white'
}

export function CallToAction({
  title,
  description,
  primaryAction,
  secondaryAction,
  className,
  variant = 'blue'
}: CallToActionProps) {
  const variantClasses = {
    blue: 'bg-blue-600',
    slate: 'bg-slate-900',
    white: 'bg-white'
  }

  const textClasses = {
    blue: 'text-white',
    slate: 'text-slate-900',
    white: 'text-slate-900'
  }

  return (
    <section className={className || variantClasses[variant]}>
      <Container>
        <div className="mx-auto max-w-lg text-center">
          <h2 className={`font-display text-3xl tracking-tight sm:text-4xl ${textClasses[variant]}`}>
            {title}
          </h2>
          <p className={`mt-4 text-lg tracking-tight ${variant === 'slate' ? 'text-slate-600' : textClasses[variant]}`}>
            {description}
          </p>
          {(primaryAction || secondaryAction) && (
            <div className="mt-10 flex justify-center gap-x-6">
              {primaryAction && (
                <Button 
                  variant="solid"
                  color={variant === 'slate' ? 'blue' : variant === 'white' ? 'slate' : 'white'}
                  onClick={primaryAction.onClick}
                  to={primaryAction.to}
                >
                  {primaryAction.text}
                </Button>
              )}
              {secondaryAction && (
                <Button 
                  variant="outline"
                  color={variant === 'slate' ? 'slate' : variant === 'white' ? 'slate' : 'white'}
                  onClick={secondaryAction.onClick}
                  to={secondaryAction.to}
                >
                  {secondaryAction.text}
                </Button>
              )}
            </div>
          )}
        </div>
      </Container>
    </section>
  )
} 